const Restart_VideoControllerMsg = /** @class */ (function () {
  function Restart_VideoControllerMsg(from, port, ...params) {
    this.type = 'restart';
    this.port = port;
    this.from = from;
  }

  Restart_VideoControllerMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Restart_VideoControllerMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Restart_VideoControllerMsg;
}());
exports.Restart_VideoControllerMsg = Restart_VideoControllerMsg;

const Stopped_WebsocketStreamMsg = /** @class */ (function () {
  function Stopped_WebsocketStreamMsg(from, port, ...params) {
    this.type = 'stopped';
    this.port = port;
    this.from = from;
  }

  Stopped_WebsocketStreamMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Stopped_WebsocketStreamMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Stopped_WebsocketStreamMsg;
}());
exports.Stopped_WebsocketStreamMsg = Stopped_WebsocketStreamMsg;

const Duration_StatusMsg = /** @class */ (function () {
  function Duration_StatusMsg(from, port, ...params) {
    this.type = 'duration';
    this.port = port;
    this.from = from;
    this.status = params[0];
    this.duration = params[1];
  }

  Duration_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Duration_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.status}, ${this.duration})`;
  };

  return Duration_StatusMsg;
}());
exports.Duration_StatusMsg = Duration_StatusMsg;

const HighLatency_LatencyWatcherMsg = /** @class */ (function () {
  function HighLatency_LatencyWatcherMsg(from, port, ...params) {
    this.type = 'highLatency';
    this.port = port;
    this.from = from;
    this.latency = params[0];
  }

  HighLatency_LatencyWatcherMsg.prototype.is = function (type) {
    return this.type === type;
  };

  HighLatency_LatencyWatcherMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.latency})`;
  };

  return HighLatency_LatencyWatcherMsg;
}());
exports.HighLatency_LatencyWatcherMsg = HighLatency_LatencyWatcherMsg;

const ResetMS_MediaSource = /** @class */ (function () {
  function ResetMS_MediaSource(from, port, ...params) {
    this.type = 'resetMS';
    this.port = port;
    this.from = from;
  }

  ResetMS_MediaSource.prototype.is = function (type) {
    return this.type === type;
  };

  ResetMS_MediaSource.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return ResetMS_MediaSource;
}());
exports.ResetMS_MediaSource = ResetMS_MediaSource;

const StartStream_ApiDigitaltTilsynMsg = /** @class */ (function () {
  function StartStream_ApiDigitaltTilsynMsg(from, port, ...params) {
    this.type = 'startStream';
    this.port = port;
    this.from = from;
    this.cameraId = params[0];
    this.ttl = params[1];
    this.profile = params[2];
  }

  StartStream_ApiDigitaltTilsynMsg.prototype.is = function (type) {
    return this.type === type;
  };

  StartStream_ApiDigitaltTilsynMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.cameraId}, ${this.ttl}, ${this.profile})`;
  };

  return StartStream_ApiDigitaltTilsynMsg;
}());
exports.StartStream_ApiDigitaltTilsynMsg = StartStream_ApiDigitaltTilsynMsg;

const Ended_Html5VideoMsg = /** @class */ (function () {
  function Ended_Html5VideoMsg(from, port, ...params) {
    this.type = 'ended';
    this.port = port;
    this.from = from;
  }

  Ended_Html5VideoMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Ended_Html5VideoMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Ended_Html5VideoMsg;
}());
exports.Ended_Html5VideoMsg = Ended_Html5VideoMsg;

const MicrophoneMuted_MicrophoneControl = /** @class */ (function () {
  function MicrophoneMuted_MicrophoneControl(from, port, ...params) {
    this.type = 'microphoneMuted';
    this.port = port;
    this.from = from;
  }

  MicrophoneMuted_MicrophoneControl.prototype.is = function (type) {
    return this.type === type;
  };

  MicrophoneMuted_MicrophoneControl.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return MicrophoneMuted_MicrophoneControl;
}());
exports.MicrophoneMuted_MicrophoneControl = MicrophoneMuted_MicrophoneControl;

const Start_LatencyWatcherMsg = /** @class */ (function () {
  function Start_LatencyWatcherMsg(from, port, ...params) {
    this.type = 'start';
    this.port = port;
    this.from = from;
  }

  Start_LatencyWatcherMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Start_LatencyWatcherMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Start_LatencyWatcherMsg;
}());
exports.Start_LatencyWatcherMsg = Start_LatencyWatcherMsg;

const Muted_Html5VideoMsg = /** @class */ (function () {
  function Muted_Html5VideoMsg(from, port, ...params) {
    this.type = 'muted';
    this.port = port;
    this.from = from;
    this.status = params[0];
  }

  Muted_Html5VideoMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Muted_Html5VideoMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.status})`;
  };

  return Muted_Html5VideoMsg;
}());
exports.Muted_Html5VideoMsg = Muted_Html5VideoMsg;

const AudioForwardingFailed_MicrophoneControl = /** @class */ (function () {
  function AudioForwardingFailed_MicrophoneControl(from, port, ...params) {
    this.type = 'audioForwardingFailed';
    this.port = port;
    this.from = from;
  }

  AudioForwardingFailed_MicrophoneControl.prototype.is = function (type) {
    return this.type === type;
  };

  AudioForwardingFailed_MicrophoneControl.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return AudioForwardingFailed_MicrophoneControl;
}());
exports.AudioForwardingFailed_MicrophoneControl = AudioForwardingFailed_MicrophoneControl;

const MediaSourceUnsupported_MediaSourceMsg = /** @class */ (function () {
  function MediaSourceUnsupported_MediaSourceMsg(from, port, ...params) {
    this.type = 'mediaSourceUnsupported';
    this.port = port;
    this.from = from;
  }

  MediaSourceUnsupported_MediaSourceMsg.prototype.is = function (type) {
    return this.type === type;
  };

  MediaSourceUnsupported_MediaSourceMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return MediaSourceUnsupported_MediaSourceMsg;
}());
exports.MediaSourceUnsupported_MediaSourceMsg = MediaSourceUnsupported_MediaSourceMsg;

const InternalUnsupported_BrowserRequirements = /** @class */ (function () {
  function InternalUnsupported_BrowserRequirements(from, port, ...params) {
    this.type = 'internalUnsupported';
    this.port = port;
    this.from = from;
  }

  InternalUnsupported_BrowserRequirements.prototype.is = function (type) {
    return this.type === type;
  };

  InternalUnsupported_BrowserRequirements.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return InternalUnsupported_BrowserRequirements;
}());
exports.InternalUnsupported_BrowserRequirements = InternalUnsupported_BrowserRequirements;

const NormalLatency_LatencyWatcherMsg = /** @class */ (function () {
  function NormalLatency_LatencyWatcherMsg(from, port, ...params) {
    this.type = 'normalLatency';
    this.port = port;
    this.from = from;
    this.latency = params[0];
  }

  NormalLatency_LatencyWatcherMsg.prototype.is = function (type) {
    return this.type === type;
  };

  NormalLatency_LatencyWatcherMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.latency})`;
  };

  return NormalLatency_LatencyWatcherMsg;
}());
exports.NormalLatency_LatencyWatcherMsg = NormalLatency_LatencyWatcherMsg;

const MediaError_Html5VideoMsg = /** @class */ (function () {
  function MediaError_Html5VideoMsg(from, port, ...params) {
    this.type = 'mediaError';
    this.port = port;
    this.from = from;
    this.errorType = params[0];
  }

  MediaError_Html5VideoMsg.prototype.is = function (type) {
    return this.type === type;
  };

  MediaError_Html5VideoMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.errorType})`;
  };

  return MediaError_Html5VideoMsg;
}());
exports.MediaError_Html5VideoMsg = MediaError_Html5VideoMsg;

const AudioForwarded_MicrophoneControl = /** @class */ (function () {
  function AudioForwarded_MicrophoneControl(from, port, ...params) {
    this.type = 'audioForwarded';
    this.port = port;
    this.from = from;
  }

  AudioForwarded_MicrophoneControl.prototype.is = function (type) {
    return this.type === type;
  };

  AudioForwarded_MicrophoneControl.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return AudioForwarded_MicrophoneControl;
}());
exports.AudioForwarded_MicrophoneControl = AudioForwarded_MicrophoneControl;

const StreamStarted_ApiDigitaltTilsynMsg = /** @class */ (function () {
  function StreamStarted_ApiDigitaltTilsynMsg(from, port, ...params) {
    this.type = 'streamStarted';
    this.port = port;
    this.from = from;
    this.cameraId = params[0];
    this.streamId = params[1];
    this.streamUrl = params[2];
    this.ttl = params[3];
  }

  StreamStarted_ApiDigitaltTilsynMsg.prototype.is = function (type) {
    return this.type === type;
  };

  StreamStarted_ApiDigitaltTilsynMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.cameraId}, ${this.streamId}, ${this.streamUrl}, ${this.ttl})`;
  };

  return StreamStarted_ApiDigitaltTilsynMsg;
}());
exports.StreamStarted_ApiDigitaltTilsynMsg = StreamStarted_ApiDigitaltTilsynMsg;

const WsError_WebsocketStream = /** @class */ (function () {
  function WsError_WebsocketStream(from, port, ...params) {
    this.type = 'wsError';
    this.port = port;
    this.from = from;
  }

  WsError_WebsocketStream.prototype.is = function (type) {
    return this.type === type;
  };

  WsError_WebsocketStream.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return WsError_WebsocketStream;
}());
exports.WsError_WebsocketStream = WsError_WebsocketStream;

const Show_ButtonMsg = /** @class */ (function () {
  function Show_ButtonMsg(from, port, ...params) {
    this.type = 'show';
    this.port = port;
    this.from = from;
  }

  Show_ButtonMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Show_ButtonMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Show_ButtonMsg;
}());
exports.Show_ButtonMsg = Show_ButtonMsg;

const UnrecoverableError_ApiDigitaltTilsynMsg = /** @class */ (function () {
  function UnrecoverableError_ApiDigitaltTilsynMsg(from, port, ...params) {
    this.type = 'unrecoverableError';
    this.port = port;
    this.from = from;
    this.msg = params[0];
  }

  UnrecoverableError_ApiDigitaltTilsynMsg.prototype.is = function (type) {
    return this.type === type;
  };

  UnrecoverableError_ApiDigitaltTilsynMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.msg})`;
  };

  return UnrecoverableError_ApiDigitaltTilsynMsg;
}());
exports.UnrecoverableError_ApiDigitaltTilsynMsg = UnrecoverableError_ApiDigitaltTilsynMsg;

const Reset_StatusMsg = /** @class */ (function () {
  function Reset_StatusMsg(from, port, ...params) {
    this.type = 'reset';
    this.port = port;
    this.from = from;
  }

  Reset_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Reset_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Reset_StatusMsg;
}());
exports.Reset_StatusMsg = Reset_StatusMsg;

const MediaError_StatusMsg = /** @class */ (function () {
  function MediaError_StatusMsg(from, port, ...params) {
    this.type = 'mediaError';
    this.port = port;
    this.from = from;
    this.err = params[0];
  }

  MediaError_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  MediaError_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.err})`;
  };

  return MediaError_StatusMsg;
}());
exports.MediaError_StatusMsg = MediaError_StatusMsg;

const WsClose_WebsocketStream = /** @class */ (function () {
  function WsClose_WebsocketStream(from, port, ...params) {
    this.type = 'wsClose';
    this.port = port;
    this.from = from;
  }

  WsClose_WebsocketStream.prototype.is = function (type) {
    return this.type === type;
  };

  WsClose_WebsocketStream.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return WsClose_WebsocketStream;
}());
exports.WsClose_WebsocketStream = WsClose_WebsocketStream;

const InternalSupported_BrowserRequirements = /** @class */ (function () {
  function InternalSupported_BrowserRequirements(from, port, ...params) {
    this.type = 'internalSupported';
    this.port = port;
    this.from = from;
  }

  InternalSupported_BrowserRequirements.prototype.is = function (type) {
    return this.type === type;
  };

  InternalSupported_BrowserRequirements.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return InternalSupported_BrowserRequirements;
}());
exports.InternalSupported_BrowserRequirements = InternalSupported_BrowserRequirements;

const Timer_cancel_TimerMsgs = /** @class */ (function () {
  function Timer_cancel_TimerMsgs(from, port, ...params) {
    this.type = 'timer_cancel';
    this.port = port;
    this.from = from;
    this.id = params[0];
  }

  Timer_cancel_TimerMsgs.prototype.is = function (type) {
    return this.type === type;
  };

  Timer_cancel_TimerMsgs.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.id})`;
  };

  return Timer_cancel_TimerMsgs;
}());
exports.Timer_cancel_TimerMsgs = Timer_cancel_TimerMsgs;

const ErrorTechnical_ApiDigitaltTilsynMsg = /** @class */ (function () {
  function ErrorTechnical_ApiDigitaltTilsynMsg(from, port, ...params) {
    this.type = 'errorTechnical';
    this.port = port;
    this.from = from;
  }

  ErrorTechnical_ApiDigitaltTilsynMsg.prototype.is = function (type) {
    return this.type === type;
  };

  ErrorTechnical_ApiDigitaltTilsynMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return ErrorTechnical_ApiDigitaltTilsynMsg;
}());
exports.ErrorTechnical_ApiDigitaltTilsynMsg = ErrorTechnical_ApiDigitaltTilsynMsg;

const Stalled_Html5VideoMsg = /** @class */ (function () {
  function Stalled_Html5VideoMsg(from, port, ...params) {
    this.type = 'stalled';
    this.port = port;
    this.from = from;
  }

  Stalled_Html5VideoMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Stalled_Html5VideoMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Stalled_Html5VideoMsg;
}());
exports.Stalled_Html5VideoMsg = Stalled_Html5VideoMsg;

const KeepAlive_KeepAliveControllerMsg = /** @class */ (function () {
  function KeepAlive_KeepAliveControllerMsg(from, port, ...params) {
    this.type = 'keepAlive';
    this.port = port;
    this.from = from;
  }

  KeepAlive_KeepAliveControllerMsg.prototype.is = function (type) {
    return this.type === type;
  };

  KeepAlive_KeepAliveControllerMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return KeepAlive_KeepAliveControllerMsg;
}());
exports.KeepAlive_KeepAliveControllerMsg = KeepAlive_KeepAliveControllerMsg;

const Playing_Html5VideoMsg = /** @class */ (function () {
  function Playing_Html5VideoMsg(from, port, ...params) {
    this.type = 'playing';
    this.port = port;
    this.from = from;
  }

  Playing_Html5VideoMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Playing_Html5VideoMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Playing_Html5VideoMsg;
}());
exports.Playing_Html5VideoMsg = Playing_Html5VideoMsg;

const PlayRejected_Html5VideoMsg = /** @class */ (function () {
  function PlayRejected_Html5VideoMsg(from, port, ...params) {
    this.type = 'playRejected';
    this.port = port;
    this.from = from;
  }

  PlayRejected_Html5VideoMsg.prototype.is = function (type) {
    return this.type === type;
  };

  PlayRejected_Html5VideoMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return PlayRejected_Html5VideoMsg;
}());
exports.PlayRejected_Html5VideoMsg = PlayRejected_Html5VideoMsg;

const Updated_MediaSource = /** @class */ (function () {
  function Updated_MediaSource(from, port, ...params) {
    this.type = 'updated';
    this.port = port;
    this.from = from;
  }

  Updated_MediaSource.prototype.is = function (type) {
    return this.type === type;
  };

  Updated_MediaSource.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Updated_MediaSource;
}());
exports.Updated_MediaSource = Updated_MediaSource;

const Play_WebsocketStreamMsg = /** @class */ (function () {
  function Play_WebsocketStreamMsg(from, port, ...params) {
    this.type = 'play';
    this.port = port;
    this.from = from;
    this.streamURL = params[0];
  }

  Play_WebsocketStreamMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Play_WebsocketStreamMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.streamURL})`;
  };

  return Play_WebsocketStreamMsg;
}());
exports.Play_WebsocketStreamMsg = Play_WebsocketStreamMsg;

const StreamError_WebsocketStreamMsg = /** @class */ (function () {
  function StreamError_WebsocketStreamMsg(from, port, ...params) {
    this.type = 'streamError';
    this.port = port;
    this.from = from;
  }

  StreamError_WebsocketStreamMsg.prototype.is = function (type) {
    return this.type === type;
  };

  StreamError_WebsocketStreamMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return StreamError_WebsocketStreamMsg;
}());
exports.StreamError_WebsocketStreamMsg = StreamError_WebsocketStreamMsg;

const Touch_ButtonMsg = /** @class */ (function () {
  function Touch_ButtonMsg(from, port, ...params) {
    this.type = 'touch';
    this.port = port;
    this.from = from;
  }

  Touch_ButtonMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Touch_ButtonMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Touch_ButtonMsg;
}());
exports.Touch_ButtonMsg = Touch_ButtonMsg;

const VideoElement_Html5VideoElementMsg = /** @class */ (function () {
  function VideoElement_Html5VideoElementMsg(from, port, ...params) {
    this.type = 'videoElement';
    this.port = port;
    this.from = from;
    this.video = params[0];
  }

  VideoElement_Html5VideoElementMsg.prototype.is = function (type) {
    return this.type === type;
  };

  VideoElement_Html5VideoElementMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.video})`;
  };

  return VideoElement_Html5VideoElementMsg;
}());
exports.VideoElement_Html5VideoElementMsg = VideoElement_Html5VideoElementMsg;

const Mute_Html5VideoMsg = /** @class */ (function () {
  function Mute_Html5VideoMsg(from, port, ...params) {
    this.type = 'mute';
    this.port = port;
    this.from = from;
    this.status = params[0];
  }

  Mute_Html5VideoMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Mute_Html5VideoMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.status})`;
  };

  return Mute_Html5VideoMsg;
}());
exports.Mute_Html5VideoMsg = Mute_Html5VideoMsg;

const Stopped_VideoControllerMsg = /** @class */ (function () {
  function Stopped_VideoControllerMsg(from, port, ...params) {
    this.type = 'stopped';
    this.port = port;
    this.from = from;
  }

  Stopped_VideoControllerMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Stopped_VideoControllerMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Stopped_VideoControllerMsg;
}());
exports.Stopped_VideoControllerMsg = Stopped_VideoControllerMsg;

const Loading_StatusMsg = /** @class */ (function () {
  function Loading_StatusMsg(from, port, ...params) {
    this.type = 'loading';
    this.port = port;
    this.from = from;
    this.isEnabled = params[0];
  }

  Loading_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Loading_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.isEnabled})`;
  };

  return Loading_StatusMsg;
}());
exports.Loading_StatusMsg = Loading_StatusMsg;

const VideoPacket_WebsocketStreamMsg = /** @class */ (function () {
  function VideoPacket_WebsocketStreamMsg(from, port, ...params) {
    this.type = 'videoPacket';
    this.port = port;
    this.from = from;
    this.data = params[0];
  }

  VideoPacket_WebsocketStreamMsg.prototype.is = function (type) {
    return this.type === type;
  };

  VideoPacket_WebsocketStreamMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.data})`;
  };

  return VideoPacket_WebsocketStreamMsg;
}());
exports.VideoPacket_WebsocketStreamMsg = VideoPacket_WebsocketStreamMsg;

const Hide_ButtonMsg = /** @class */ (function () {
  function Hide_ButtonMsg(from, port, ...params) {
    this.type = 'hide';
    this.port = port;
    this.from = from;
  }

  Hide_ButtonMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Hide_ButtonMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Hide_ButtonMsg;
}());
exports.Hide_ButtonMsg = Hide_ButtonMsg;

const MediaSourceFailure_MediaSourceMsg = /** @class */ (function () {
  function MediaSourceFailure_MediaSourceMsg(from, port, ...params) {
    this.type = 'mediaSourceFailure';
    this.port = port;
    this.from = from;
  }

  MediaSourceFailure_MediaSourceMsg.prototype.is = function (type) {
    return this.type === type;
  };

  MediaSourceFailure_MediaSourceMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return MediaSourceFailure_MediaSourceMsg;
}());
exports.MediaSourceFailure_MediaSourceMsg = MediaSourceFailure_MediaSourceMsg;

const WsMessage_WebsocketStream = /** @class */ (function () {
  function WsMessage_WebsocketStream(from, port, ...params) {
    this.type = 'wsMessage';
    this.port = port;
    this.from = from;
  }

  WsMessage_WebsocketStream.prototype.is = function (type) {
    return this.type === type;
  };

  WsMessage_WebsocketStream.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return WsMessage_WebsocketStream;
}());
exports.WsMessage_WebsocketStream = WsMessage_WebsocketStream;

const Playing_WebsocketStreamMsg = /** @class */ (function () {
  function Playing_WebsocketStreamMsg(from, port, ...params) {
    this.type = 'playing';
    this.port = port;
    this.from = from;
  }

  Playing_WebsocketStreamMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Playing_WebsocketStreamMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Playing_WebsocketStreamMsg;
}());
exports.Playing_WebsocketStreamMsg = Playing_WebsocketStreamMsg;

const UpdateTtl_StatusMsg = /** @class */ (function () {
  function UpdateTtl_StatusMsg(from, port, ...params) {
    this.type = 'updateTtl';
    this.port = port;
    this.from = from;
    this.ttl = params[0];
  }

  UpdateTtl_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  UpdateTtl_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.ttl})`;
  };

  return UpdateTtl_StatusMsg;
}());
exports.UpdateTtl_StatusMsg = UpdateTtl_StatusMsg;

const Timer_start_TimerMsgs = /** @class */ (function () {
  function Timer_start_TimerMsgs(from, port, ...params) {
    this.type = 'timer_start';
    this.port = port;
    this.from = from;
    this.id = params[0];
    this.time = params[1];
  }

  Timer_start_TimerMsgs.prototype.is = function (type) {
    return this.type === type;
  };

  Timer_start_TimerMsgs.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.id}, ${this.time})`;
  };

  return Timer_start_TimerMsgs;
}());
exports.Timer_start_TimerMsgs = Timer_start_TimerMsgs;

const MediaSourceStop_MediaSourceMsg = /** @class */ (function () {
  function MediaSourceStop_MediaSourceMsg(from, port, ...params) {
    this.type = 'mediaSourceStop';
    this.port = port;
    this.from = from;
  }

  MediaSourceStop_MediaSourceMsg.prototype.is = function (type) {
    return this.type === type;
  };

  MediaSourceStop_MediaSourceMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return MediaSourceStop_MediaSourceMsg;
}());
exports.MediaSourceStop_MediaSourceMsg = MediaSourceStop_MediaSourceMsg;

const Unrecoverable_StatusMsg = /** @class */ (function () {
  function Unrecoverable_StatusMsg(from, port, ...params) {
    this.type = 'unrecoverable';
    this.port = port;
    this.from = from;
    this.isEnabled = params[0];
  }

  Unrecoverable_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Unrecoverable_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.isEnabled})`;
  };

  return Unrecoverable_StatusMsg;
}());
exports.Unrecoverable_StatusMsg = Unrecoverable_StatusMsg;

const Terminate_MicrophoneControl = /** @class */ (function () {
  function Terminate_MicrophoneControl(from, port, ...params) {
    this.type = 'terminate';
    this.port = port;
    this.from = from;
  }

  Terminate_MicrophoneControl.prototype.is = function (type) {
    return this.type === type;
  };

  Terminate_MicrophoneControl.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Terminate_MicrophoneControl;
}());
exports.Terminate_MicrophoneControl = Terminate_MicrophoneControl;

const Stop_LatencyWatcherMsg = /** @class */ (function () {
  function Stop_LatencyWatcherMsg(from, port, ...params) {
    this.type = 'stop';
    this.port = port;
    this.from = from;
  }

  Stop_LatencyWatcherMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Stop_LatencyWatcherMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Stop_LatencyWatcherMsg;
}());
exports.Stop_LatencyWatcherMsg = Stop_LatencyWatcherMsg;

const WebsocketStatus_StatusMsg = /** @class */ (function () {
  function WebsocketStatus_StatusMsg(from, port, ...params) {
    this.type = 'websocketStatus';
    this.port = port;
    this.from = from;
    this.status = params[0];
  }

  WebsocketStatus_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  WebsocketStatus_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.status})`;
  };

  return WebsocketStatus_StatusMsg;
}());
exports.WebsocketStatus_StatusMsg = WebsocketStatus_StatusMsg;

const Broken_StatusMsg = /** @class */ (function () {
  function Broken_StatusMsg(from, port, ...params) {
    this.type = 'broken';
    this.port = port;
    this.from = from;
    this.isEnabled = params[0];
  }

  Broken_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Broken_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.isEnabled})`;
  };

  return Broken_StatusMsg;
}());
exports.Broken_StatusMsg = Broken_StatusMsg;

const Waiting_StatusMsg = /** @class */ (function () {
  function Waiting_StatusMsg(from, port, ...params) {
    this.type = 'waiting';
    this.port = port;
    this.from = from;
    this.isEnabled = params[0];
  }

  Waiting_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Waiting_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.isEnabled})`;
  };

  return Waiting_StatusMsg;
}());
exports.Waiting_StatusMsg = Waiting_StatusMsg;

const KeepAliveWarning_KeepAliveControllerMsg = /** @class */ (function () {
  function KeepAliveWarning_KeepAliveControllerMsg(from, port, ...params) {
    this.type = 'keepAliveWarning';
    this.port = port;
    this.from = from;
    this.status = params[0];
  }

  KeepAliveWarning_KeepAliveControllerMsg.prototype.is = function (type) {
    return this.type === type;
  };

  KeepAliveWarning_KeepAliveControllerMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.status})`;
  };

  return KeepAliveWarning_KeepAliveControllerMsg;
}());
exports.KeepAliveWarning_KeepAliveControllerMsg = KeepAliveWarning_KeepAliveControllerMsg;

const Stalled_StatusMsg = /** @class */ (function () {
  function Stalled_StatusMsg(from, port, ...params) {
    this.type = 'stalled';
    this.port = port;
    this.from = from;
    this.isEnabled = params[0];
  }

  Stalled_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Stalled_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.isEnabled})`;
  };

  return Stalled_StatusMsg;
}());
exports.Stalled_StatusMsg = Stalled_StatusMsg;

const StreamTtl_ApiDigitaltTilsynMsg = /** @class */ (function () {
  function StreamTtl_ApiDigitaltTilsynMsg(from, port, ...params) {
    this.type = 'streamTtl';
    this.port = port;
    this.from = from;
    this.cameraId = params[0];
    this.streamId = params[1];
    this.ttl = params[2];
  }

  StreamTtl_ApiDigitaltTilsynMsg.prototype.is = function (type) {
    return this.type === type;
  };

  StreamTtl_ApiDigitaltTilsynMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.cameraId}, ${this.streamId}, ${this.ttl})`;
  };

  return StreamTtl_ApiDigitaltTilsynMsg;
}());
exports.StreamTtl_ApiDigitaltTilsynMsg = StreamTtl_ApiDigitaltTilsynMsg;

const Waiting_WaitingWatcherMsg = /** @class */ (function () {
  function Waiting_WaitingWatcherMsg(from, port, ...params) {
    this.type = 'waiting';
    this.port = port;
    this.from = from;
    this.waited = params[0];
  }

  Waiting_WaitingWatcherMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Waiting_WaitingWatcherMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.waited})`;
  };

  return Waiting_WaitingWatcherMsg;
}());
exports.Waiting_WaitingWatcherMsg = Waiting_WaitingWatcherMsg;

const Touch_MuteButton = /** @class */ (function () {
  function Touch_MuteButton(from, port, ...params) {
    this.type = 'touch';
    this.port = port;
    this.from = from;
  }

  Touch_MuteButton.prototype.is = function (type) {
    return this.type === type;
  };

  Touch_MuteButton.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Touch_MuteButton;
}());
exports.Touch_MuteButton = Touch_MuteButton;

const AutoRestartCount_StatusMsg = /** @class */ (function () {
  function AutoRestartCount_StatusMsg(from, port, ...params) {
    this.type = 'autoRestartCount';
    this.port = port;
    this.from = from;
    this.count = params[0];
  }

  AutoRestartCount_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  AutoRestartCount_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.count})`;
  };

  return AutoRestartCount_StatusMsg;
}());
exports.AutoRestartCount_StatusMsg = AutoRestartCount_StatusMsg;

const WaitedTooLong_StatusMsg = /** @class */ (function () {
  function WaitedTooLong_StatusMsg(from, port, ...params) {
    this.type = 'waitedTooLong';
    this.port = port;
    this.from = from;
    this.isEnabled = params[0];
  }

  WaitedTooLong_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  WaitedTooLong_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.isEnabled})`;
  };

  return WaitedTooLong_StatusMsg;
}());
exports.WaitedTooLong_StatusMsg = WaitedTooLong_StatusMsg;

const Toggle_MicrophoneControl = /** @class */ (function () {
  function Toggle_MicrophoneControl(from, port, ...params) {
    this.type = 'toggle';
    this.port = port;
    this.from = from;
  }

  Toggle_MicrophoneControl.prototype.is = function (type) {
    return this.type === type;
  };

  Toggle_MicrophoneControl.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Toggle_MicrophoneControl;
}());
exports.Toggle_MicrophoneControl = Toggle_MicrophoneControl;

const Timer_timeout_TimerMsgs = /** @class */ (function () {
  function Timer_timeout_TimerMsgs(from, port, ...params) {
    this.type = 'timer_timeout';
    this.port = port;
    this.from = from;
    this.id = params[0];
  }

  Timer_timeout_TimerMsgs.prototype.is = function (type) {
    return this.type === type;
  };

  Timer_timeout_TimerMsgs.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.id})`;
  };

  return Timer_timeout_TimerMsgs;
}());
exports.Timer_timeout_TimerMsgs = Timer_timeout_TimerMsgs;

const StopStream_ApiDigitaltTilsynMsg = /** @class */ (function () {
  function StopStream_ApiDigitaltTilsynMsg(from, port, ...params) {
    this.type = 'stopStream';
    this.port = port;
    this.from = from;
    this.cameraId = params[0];
    this.streamId = params[1];
  }

  StopStream_ApiDigitaltTilsynMsg.prototype.is = function (type) {
    return this.type === type;
  };

  StopStream_ApiDigitaltTilsynMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.cameraId}, ${this.streamId})`;
  };

  return StopStream_ApiDigitaltTilsynMsg;
}());
exports.StopStream_ApiDigitaltTilsynMsg = StopStream_ApiDigitaltTilsynMsg;

const Stalled_AntiStallMsg = /** @class */ (function () {
  function Stalled_AntiStallMsg(from, port, ...params) {
    this.type = 'stalled';
    this.port = port;
    this.from = from;
  }

  Stalled_AntiStallMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Stalled_AntiStallMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Stalled_AntiStallMsg;
}());
exports.Stalled_AntiStallMsg = Stalled_AntiStallMsg;

const Log_WebsocketStreamMsg = /** @class */ (function () {
  function Log_WebsocketStreamMsg(from, port, ...params) {
    this.type = 'log';
    this.port = port;
    this.from = from;
    this.payload = params[0];
  }

  Log_WebsocketStreamMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Log_WebsocketStreamMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.payload})`;
  };

  return Log_WebsocketStreamMsg;
}());
exports.Log_WebsocketStreamMsg = Log_WebsocketStreamMsg;

const ErrorStreamUnavailable_ApiDigitaltTilsynMsg = /** @class */ (function () {
  function ErrorStreamUnavailable_ApiDigitaltTilsynMsg(from, port, ...params) {
    this.type = 'errorStreamUnavailable';
    this.port = port;
    this.from = from;
  }

  ErrorStreamUnavailable_ApiDigitaltTilsynMsg.prototype.is = function (type) {
    return this.type === type;
  };

  ErrorStreamUnavailable_ApiDigitaltTilsynMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return ErrorStreamUnavailable_ApiDigitaltTilsynMsg;
}());
exports.ErrorStreamUnavailable_ApiDigitaltTilsynMsg = ErrorStreamUnavailable_ApiDigitaltTilsynMsg;

const PageVisible_VideoVisibility = /** @class */ (function () {
  function PageVisible_VideoVisibility(from, port, ...params) {
    this.type = 'pageVisible';
    this.port = port;
    this.from = from;
  }

  PageVisible_VideoVisibility.prototype.is = function (type) {
    return this.type === type;
  };

  PageVisible_VideoVisibility.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return PageVisible_VideoVisibility;
}());
exports.PageVisible_VideoVisibility = PageVisible_VideoVisibility;

const Stop_VideoControllerMsg = /** @class */ (function () {
  function Stop_VideoControllerMsg(from, port, ...params) {
    this.type = 'stop';
    this.port = port;
    this.from = from;
  }

  Stop_VideoControllerMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Stop_VideoControllerMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Stop_VideoControllerMsg;
}());
exports.Stop_VideoControllerMsg = Stop_VideoControllerMsg;

const Start_AntiStallMsg = /** @class */ (function () {
  function Start_AntiStallMsg(from, port, ...params) {
    this.type = 'start';
    this.port = port;
    this.from = from;
  }

  Start_AntiStallMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Start_AntiStallMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Start_AntiStallMsg;
}());
exports.Start_AntiStallMsg = Start_AntiStallMsg;

const Play_Html5VideoMsg = /** @class */ (function () {
  function Play_Html5VideoMsg(from, port, ...params) {
    this.type = 'play';
    this.port = port;
    this.from = from;
  }

  Play_Html5VideoMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Play_Html5VideoMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Play_Html5VideoMsg;
}());
exports.Play_Html5VideoMsg = Play_Html5VideoMsg;

const Play_VideoControllerMsg = /** @class */ (function () {
  function Play_VideoControllerMsg(from, port, ...params) {
    this.type = 'play';
    this.port = port;
    this.from = from;
  }

  Play_VideoControllerMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Play_VideoControllerMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Play_VideoControllerMsg;
}());
exports.Play_VideoControllerMsg = Play_VideoControllerMsg;

const KeepStreamAlive_ApiDigitaltTilsynMsg = /** @class */ (function () {
  function KeepStreamAlive_ApiDigitaltTilsynMsg(from, port, ...params) {
    this.type = 'keepStreamAlive';
    this.port = port;
    this.from = from;
    this.cameraId = params[0];
    this.streamId = params[1];
    this.ttl = params[2];
  }

  KeepStreamAlive_ApiDigitaltTilsynMsg.prototype.is = function (type) {
    return this.type === type;
  };

  KeepStreamAlive_ApiDigitaltTilsynMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.cameraId}, ${this.streamId}, ${this.ttl})`;
  };

  return KeepStreamAlive_ApiDigitaltTilsynMsg;
}());
exports.KeepStreamAlive_ApiDigitaltTilsynMsg = KeepStreamAlive_ApiDigitaltTilsynMsg;

const Clear_Html5VideoMsg = /** @class */ (function () {
  function Clear_Html5VideoMsg(from, port, ...params) {
    this.type = 'clear';
    this.port = port;
    this.from = from;
  }

  Clear_Html5VideoMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Clear_Html5VideoMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Clear_Html5VideoMsg;
}());
exports.Clear_Html5VideoMsg = Clear_Html5VideoMsg;

const WsOpen_WebsocketStream = /** @class */ (function () {
  function WsOpen_WebsocketStream(from, port, ...params) {
    this.type = 'wsOpen';
    this.port = port;
    this.from = from;
  }

  WsOpen_WebsocketStream.prototype.is = function (type) {
    return this.type === type;
  };

  WsOpen_WebsocketStream.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return WsOpen_WebsocketStream;
}());
exports.WsOpen_WebsocketStream = WsOpen_WebsocketStream;

const UnmuteMicrophone_MicrophoneControl = /** @class */ (function () {
  function UnmuteMicrophone_MicrophoneControl(from, port, ...params) {
    this.type = 'unmuteMicrophone';
    this.port = port;
    this.from = from;
  }

  UnmuteMicrophone_MicrophoneControl.prototype.is = function (type) {
    return this.type === type;
  };

  UnmuteMicrophone_MicrophoneControl.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return UnmuteMicrophone_MicrophoneControl;
}());
exports.UnmuteMicrophone_MicrophoneControl = UnmuteMicrophone_MicrophoneControl;

const TechnicalError_StatusMsg = /** @class */ (function () {
  function TechnicalError_StatusMsg(from, port, ...params) {
    this.type = 'technicalError';
    this.port = port;
    this.from = from;
    this.err = params[0];
  }

  TechnicalError_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  TechnicalError_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.err})`;
  };

  return TechnicalError_StatusMsg;
}());
exports.TechnicalError_StatusMsg = TechnicalError_StatusMsg;

const Playing_VideoControllerMsg = /** @class */ (function () {
  function Playing_VideoControllerMsg(from, port, ...params) {
    this.type = 'playing';
    this.port = port;
    this.from = from;
  }

  Playing_VideoControllerMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Playing_VideoControllerMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Playing_VideoControllerMsg;
}());
exports.Playing_VideoControllerMsg = Playing_VideoControllerMsg;

const MediaSourceVideoElement_MediaSourceMsg = /** @class */ (function () {
  function MediaSourceVideoElement_MediaSourceMsg(from, port, ...params) {
    this.type = 'mediaSourceVideoElement';
    this.port = port;
    this.from = from;
    this.video = params[0];
  }

  MediaSourceVideoElement_MediaSourceMsg.prototype.is = function (type) {
    return this.type === type;
  };

  MediaSourceVideoElement_MediaSourceMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.video})`;
  };

  return MediaSourceVideoElement_MediaSourceMsg;
}());
exports.MediaSourceVideoElement_MediaSourceMsg = MediaSourceVideoElement_MediaSourceMsg;

const MuteMicrophone_MicrophoneControl = /** @class */ (function () {
  function MuteMicrophone_MicrophoneControl(from, port, ...params) {
    this.type = 'muteMicrophone';
    this.port = port;
    this.from = from;
  }

  MuteMicrophone_MicrophoneControl.prototype.is = function (type) {
    return this.type === type;
  };

  MuteMicrophone_MicrophoneControl.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return MuteMicrophone_MicrophoneControl;
}());
exports.MuteMicrophone_MicrophoneControl = MuteMicrophone_MicrophoneControl;

const Sound_Html5VideoMsg = /** @class */ (function () {
  function Sound_Html5VideoMsg(from, port, ...params) {
    this.type = 'sound';
    this.port = port;
    this.from = from;
    this.status = params[0];
  }

  Sound_Html5VideoMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Sound_Html5VideoMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.status})`;
  };

  return Sound_Html5VideoMsg;
}());
exports.Sound_Html5VideoMsg = Sound_Html5VideoMsg;

const Delayed_StatusMsg = /** @class */ (function () {
  function Delayed_StatusMsg(from, port, ...params) {
    this.type = 'delayed';
    this.port = port;
    this.from = from;
    this.isEnabled = params[0];
  }

  Delayed_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Delayed_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.isEnabled})`;
  };

  return Delayed_StatusMsg;
}());
exports.Delayed_StatusMsg = Delayed_StatusMsg;

const Stop_AntiStallMsg = /** @class */ (function () {
  function Stop_AntiStallMsg(from, port, ...params) {
    this.type = 'stop';
    this.port = port;
    this.from = from;
  }

  Stop_AntiStallMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Stop_AntiStallMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Stop_AntiStallMsg;
}());
exports.Stop_AntiStallMsg = Stop_AntiStallMsg;

const Stop_WebsocketStreamMsg = /** @class */ (function () {
  function Stop_WebsocketStreamMsg(from, port, ...params) {
    this.type = 'stop';
    this.port = port;
    this.from = from;
  }

  Stop_WebsocketStreamMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Stop_WebsocketStreamMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Stop_WebsocketStreamMsg;
}());
exports.Stop_WebsocketStreamMsg = Stop_WebsocketStreamMsg;

const Running_AntiStallMsg = /** @class */ (function () {
  function Running_AntiStallMsg(from, port, ...params) {
    this.type = 'running';
    this.port = port;
    this.from = from;
  }

  Running_AntiStallMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Running_AntiStallMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Running_AntiStallMsg;
}());
exports.Running_AntiStallMsg = Running_AntiStallMsg;

const Timeout_WebsocketStreamMsg = /** @class */ (function () {
  function Timeout_WebsocketStreamMsg(from, port, ...params) {
    this.type = 'timeout';
    this.port = port;
    this.from = from;
  }

  Timeout_WebsocketStreamMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Timeout_WebsocketStreamMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Timeout_WebsocketStreamMsg;
}());
exports.Timeout_WebsocketStreamMsg = Timeout_WebsocketStreamMsg;

const PageHidden_VideoVisibility = /** @class */ (function () {
  function PageHidden_VideoVisibility(from, port, ...params) {
    this.type = 'pageHidden';
    this.port = port;
    this.from = from;
  }

  PageHidden_VideoVisibility.prototype.is = function (type) {
    return this.type === type;
  };

  PageHidden_VideoVisibility.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return PageHidden_VideoVisibility;
}());
exports.PageHidden_VideoVisibility = PageHidden_VideoVisibility;

const ForwardAudio_MicrophoneControl = /** @class */ (function () {
  function ForwardAudio_MicrophoneControl(from, port, ...params) {
    this.type = 'forwardAudio';
    this.port = port;
    this.from = from;
  }

  ForwardAudio_MicrophoneControl.prototype.is = function (type) {
    return this.type === type;
  };

  ForwardAudio_MicrophoneControl.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return ForwardAudio_MicrophoneControl;
}());
exports.ForwardAudio_MicrophoneControl = ForwardAudio_MicrophoneControl;

const AudioHash_MicrophoneControl = /** @class */ (function () {
  function AudioHash_MicrophoneControl(from, port, ...params) {
    this.type = 'audioHash';
    this.port = port;
    this.from = from;
    this.hash = params[0];
  }

  AudioHash_MicrophoneControl.prototype.is = function (type) {
    return this.type === type;
  };

  AudioHash_MicrophoneControl.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.hash})`;
  };

  return AudioHash_MicrophoneControl;
}());
exports.AudioHash_MicrophoneControl = AudioHash_MicrophoneControl;

const Unavailable_StatusMsg = /** @class */ (function () {
  function Unavailable_StatusMsg(from, port, ...params) {
    this.type = 'unavailable';
    this.port = port;
    this.from = from;
    this.isEnabled = params[0];
  }

  Unavailable_StatusMsg.prototype.is = function (type) {
    return this.type === type;
  };

  Unavailable_StatusMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.isEnabled})`;
  };

  return Unavailable_StatusMsg;
}());
exports.Unavailable_StatusMsg = Unavailable_StatusMsg;

const Ready_MediaSource = /** @class */ (function () {
  function Ready_MediaSource(from, port, ...params) {
    this.type = 'ready';
    this.port = port;
    this.from = from;
  }

  Ready_MediaSource.prototype.is = function (type) {
    return this.type === type;
  };

  Ready_MediaSource.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return Ready_MediaSource;
}());
exports.Ready_MediaSource = Ready_MediaSource;

const MicrophoneUnmuted_MicrophoneControl = /** @class */ (function () {
  function MicrophoneUnmuted_MicrophoneControl(from, port, ...params) {
    this.type = 'microphoneUnmuted';
    this.port = port;
    this.from = from;
  }

  MicrophoneUnmuted_MicrophoneControl.prototype.is = function (type) {
    return this.type === type;
  };

  MicrophoneUnmuted_MicrophoneControl.prototype.toString = function () {
    return `event ${this.type}?${this.port}()`;
  };

  return MicrophoneUnmuted_MicrophoneControl;
}());
exports.MicrophoneUnmuted_MicrophoneControl = MicrophoneUnmuted_MicrophoneControl;

const FormatPacket_WebsocketStreamMsg = /** @class */ (function () {
  function FormatPacket_WebsocketStreamMsg(from, port, ...params) {
    this.type = 'formatPacket';
    this.port = port;
    this.from = from;
    this.format = params[0];
  }

  FormatPacket_WebsocketStreamMsg.prototype.is = function (type) {
    return this.type === type;
  };

  FormatPacket_WebsocketStreamMsg.prototype.toString = function () {
    return `event ${this.type}?${this.port}(${this.format})`;
  };

  return FormatPacket_WebsocketStreamMsg;
}());
exports.FormatPacket_WebsocketStreamMsg = FormatPacket_WebsocketStreamMsg;
